import { auditsApiMock } from './audits-api.mock.ts'
import { auditsApiProd } from './audits-api.prod.ts'
import type { AuditsApi } from './audits-api.types.ts'

/**
 * The one swap point (#240): feature code imports `auditsApi` from here and
 * never from `.prod` or `.mock`. `VITE_AUDITS_MOCK=true` renders both pages
 * without an engine.
 */
export const auditsApi: AuditsApi =
  import.meta.env.VITE_AUDITS_MOCK === 'true' ? auditsApiMock : auditsApiProd

export type { AuditsApi, AuditsApiError, ApiResult } from './audits-api.types.ts'
